export default __webpack_public_path__ + "static/media/FOTO JERSU - SITE 01 (1).4ac8c763.png";